import React, { useState } from 'react';
import MainLayout from '../../components/ui/MainLayout';
import BuildingSelector from './components/BuildingSelector';
import PerformanceMetricCard from './components/PerformanceMetricCard';
import RadarChart from './components/RadarChart';
import RankingTable from './components/RankingTable';
import ComparisonMatrix from './components/ComparisonMatrix';
import PerformanceAlerts from './components/PerformanceAlerts';
import Select from '../../components/ui/Select';

const BuildingPerformance = () => {
  const availableBuildings = [
    { id: 'f1', name: 'F1', totalRooms: 96, floors: 5 },
    { id: 'f2', name: 'F2', totalRooms: 96, floors: 5 },
    { id: 'g1', name: 'G1', totalRooms: 96, floors: 5 },
    { id: 'g2', name: 'G2', totalRooms: 96, floors: 5 },
    { id: 'h', name: 'H', totalRooms: 38, floors: 5 },
    { id: 'l', name: 'L', totalRooms: 13, floors: 1 }
  ];

  const [selectedBuildings, setSelectedBuildings] = useState(['f1', 'f2']);
  const [performancePeriod, setPerformancePeriod] = useState('30days');

  const periodOptions = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '90days', label: 'Last 90 Days' },
    { value: 'ytd', label: 'Year to Date' }
  ];

  const performanceMetrics = [
    {
      type: 'occupancy',
      label: 'Occupancy Rate',
      description: 'Current room utilization'
    },
    {
      type: 'maintenance',
      label: 'Maintenance Response',
      description: 'Average response time'
    },
    {
      type: 'satisfaction',
      label: 'Resident Satisfaction',
      description: 'Overall satisfaction score'
    },
    {
      type: 'revenue',
      label: 'Revenue per Room',
      description: 'Monthly average'
    }
  ];

  const getMetricData = (metricType) => {
    return [];
  };

  const radarData = [];

  const rankingData = [];

  const comparisonMetrics = [
    { key: 'responseTime', label: 'Avg Response Time', unit: 'Hours', icon: 'Clock', type: 'time' },
    { key: 'completionRate', label: 'Request Completion', unit: 'Percentage', icon: 'CheckCircle', type: 'percentage' },
    { key: 'maintenanceCost', label: 'Monthly Maintenance', unit: 'USD', icon: 'DollarSign', type: 'currency' },
    { key: 'energyEfficiency', label: 'Energy Efficiency', unit: 'Score', icon: 'Zap', type: 'percentage' }
  ];

  const buildingsWithMetrics = [];

  const performanceAlerts = [];

  const selectedBuildingObjects = availableBuildings?.filter(b => selectedBuildings?.includes(b?.id));

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
              Building Performance Analytics
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Comparative facility analysis and operational benchmarking
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Select
              options={periodOptions}
              value={performancePeriod}
              onChange={setPerformancePeriod}
              placeholder="Select period"
              className="w-full sm:w-48"
            />
          </div>
        </div>

        <BuildingSelector
          selectedBuildings={selectedBuildings}
          onBuildingChange={setSelectedBuildings}
          availableBuildings={availableBuildings}
        />

        {selectedBuildings?.length > 0 && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {performanceMetrics?.map((metric, index) => (
                <PerformanceMetricCard
                  key={index}
                  metric={metric}
                  buildingData={getMetricData(metric?.type)}
                />
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
              <div className="lg:col-span-2">
                <RadarChart data={radarData} buildings={selectedBuildingObjects} />
              </div>
              <div>
                <RankingTable buildings={rankingData?.filter(b => selectedBuildings?.includes(b?.id))} />
              </div>
            </div>

            <ComparisonMatrix buildings={buildingsWithMetrics} metrics={comparisonMetrics} />

            <PerformanceAlerts alerts={performanceAlerts} />
          </>
        )}
      </div>
    </MainLayout>
  );
};

export default BuildingPerformance;